import {
  CompanyLegalBeneficiary,
  OnboardingCompanyProfile,
} from '__generated__/GQL';
import getCurrentLegalBeneficiary from 'features/Onboarding/lib/getCurrentLegalBeneficiary';
import getIsEi from 'features/Onboarding/lib/getIsEi';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getBusinessRoleStatus = ({
  companyLegalBeneficiaries,
  companyProfile,
}: {
  companyProfile: Pick<OnboardingCompanyProfile, 'legalForm'>;
  companyLegalBeneficiaries: Pick<
    CompanyLegalBeneficiary,
    | 'companyLegalBeneficiaryId'
    | 'isCurrentUser'
    | 'isDirector'
    | 'isMajorShareholder'
  >[];
}) => {
  const isEi = getIsEi(companyProfile);

  if (isEi) {
    return VerificationStatus.Irrelevant;
  }

  const currentLegalBeneficiary = getCurrentLegalBeneficiary(
    companyLegalBeneficiaries,
  );

  if (
    !currentLegalBeneficiary ||
    currentLegalBeneficiary.isDirector === null ||
    currentLegalBeneficiary.isMajorShareholder === null
  ) {
    return VerificationStatus.ToDo;
  }

  return currentLegalBeneficiary.isDirector
    ? VerificationStatus.Completed
    : VerificationStatus.Invalid;
};

export default getBusinessRoleStatus;
